<template>
  <div>
    <Mainlayout></Mainlayout>
    <CCard class="h-100">
      <CCol sm="12" class="justify-content-center mt-5 m-0">
        <CContainer>
            <CCol sm="12" lg="12" class="custom-margin mt-5">
            <br />
            <br />
            <br />
 <br />
     
   <h4
              class="text-left mt-4 text-black bold"
              style="font-size: 24px"
            >
              Quiz Preview
            </h4>
            <CCard color="light" class="p-2 custom-font">
             
              <CCol sm="12" lg="12">
                <CRow>
                <div class="col-3">
                  <h1
                    style="
                      font-size: revert;
                      text-transform: uppercase;
                      color: #fff;
                    "
                  class="square-bg p-1 box-shadow"
                  >
                  <span>{{ qSummary.subjectName.substring(0, 1) }}</span>
                  </h1>
                </div>
                <div class="col-9">
                  <h5 class="mb-0">{{ qSummary.subjectName }}</h5>
                 <span class="small text-muted"> <strong>Grade : {{ qSummary.gradeName }} </strong></span>
                 
                </div>
                </CRow>
              </CCol>
            </CCard>
            <hr />
            <h4>Details</h4>

           
            <CCard color="light" class="p-2 mb-2 custom-font">
              <CRow>
                <div class="col-4 text-left">Title</div>
                <div class="col-8 text-right">
                  <strong>{{ qSummary.Title }}</strong>
                </div>
              </CRow>
            </CCard>

            <CCard color="light" class="p-2 mb-2 custom-font">
              <CRow>
                <div class="col-6 text-left">Question Amount</div>
                <div class="col-6 text-right">
                  <strong>{{ qSummary.questionCount }} Questions</strong>
                </div>
              </CRow>
            </CCard>

            <CCard color="light" class="p-2 mb-2 custom-font">
              <CRow>
                <div class="col-6 text-left">Timer</div>
                <div class="col-6 text-right">
                  <strong>{{ qSummary.TimerString }}</strong>
                </div>
              </CRow>
            </CCard>

            <CCard color="light" class="p-2 mb-2 custom-font">
              <CRow>
                <div class="col-5 text-left">Publish By</div>
                <div class="col-7 text-right">
                  <strong>{{ qSummary.TeacherName }}</strong>
                </div>
              </CRow>
            </CCard>

            <CCard color="light" class="p-2 mb-2 custom-font">
              <CRow>
                <div class="col-6 text-left">Publish Date</div>
                <div class="col-6 text-right">
                  <strong>{{ qSummary.CreatedDate | moment("DD MMM YYYY") }}</strong>
                </div>
              </CRow>
            </CCard>
            <hr />
           
            <br />
            <div>
              <!-- <CButton
                color="success"
                class="custom-btn mt-4"
                size="lg"
                block
                :disabled="isDisabled"
                @click="StudentStartQuiz"
              >Take Quiz</CButton> -->


              <CRow>
                <CCol sm="6"> 
                 
                  <CButton
                color="success"
                class="custom-btn mt-4"
                size="lg"
                block
                disabled
                > <CIcon name="cil-clone" class="mr-2"/>Take Quiz One By One</CButton
              ></CCol>
                <CCol sm="6">
                  <CButton
                color="success"
                class="custom-btn-blueblack mt-4 mr-2"
                size="lg"
                block
                :disabled="isDisabled"
                @click="StudentStartQuizAll"
                ><CIcon name="cil-window-maximize" class="mr-2"/> Take Quiz in One Page</CButton
              >
                </CCol>
              </CRow>
            </div>
            <div>
              <CButton
                color="success"
                class="custom-btn mt-1 mb-4"
                size="lg"
                block
                :disabled="isDisabled"
                @click="GoToDashBoard"
              >Close</CButton>
            </div>
            </CCol>
        </CContainer>
      </CCol>
    </CCard>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-sm-flex"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0">Create Quiz</h3>
        <br />
        <br />
      </div>
    </div>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundUrl from "../assets/img/backgroundTutor.png";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "../containers/TheHeaderStudentCustom.vue";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  // childs: [],
  // SelectedStudent: "",
  qSummary: {},
  components: {
    PulseLoader,
    Mainlayout
  },
  data() {
    return {
      backgroundBanner,
      SubmittedForm: false,
      // childs: [],
      // SelectedStudent: "",
      endTime: "",
      timestamp: "",
      qSummary: {},
      Error: false
    };
  },
  async mounted() {
    this.GetQuizPreview();
    this.GetListChild();
  },
  computed: {},
  methods: {
    //Get quiz summary
    async GetQuizPreview() {
      return this.$API
        .get(this.$QuizPreview + "?quizId=" + this.$route.query.quizId,
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.qSummary = response.data;
            console.log(this.qSummary);
            }
          }
        )
        .catch(function(error) {
          console.log(error.response);
        });
    },
    // async GetListChild() {
    //   this.$API
    //     .get(this.$ListChild + "?userID=" + this.$route.query.userId, {
    //       withCredentials: true,
    //     })
    //     .then((response) => {
    //       if (response.status == 200 && response.data != null) {
    //         this.childs = response.data;
    //       }
    //     });
    // },
    StudentStartQuiz() {
      const formData = new FormData();
      formData.append("quizId", this.$route.query.quizId);
      formData.append("studentId", this.$route.query.studentId);

      return this.$API
        .post(this.$StudentStartQuiz, formData, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            var startId = response.data;
            this.getNow(
              this.qSummary.d,
              this.qSummary.h,
              this.qSummary.m,
              this.qSummary.s
            );
            console.log(this.timestamp);
            this.GoToQuiz(startId, this.timestamp);
          }
        })
        .catch(error => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
          }
        });
    },
    getNow: function(d, h, m, s) {
      const today = new Date();
      const date =
        today.getFullYear() +
        "-" +
        ("0" + (today.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + (today.getDate() + d)).slice(-2);
      let Chour = today.getHours() + h;
      let Cminute = today.getMinutes() + m;
      let Csecond = today.getSeconds() + s;
      if (Csecond > 60) {
        Csecond -= 60;
        Cminute += 1;
      } else if (Cminute > 60) {
        Cminute -= 60;
        Chour += 1;
      } else {
      }
      const time =
        ("0" + Chour).slice(-2) +
        ":" +
        ("0" + Cminute).slice(-2) +
        ":" +
        ("0" + Csecond).slice(-2);
      const dateTime = date + "T" + time;
      this.timestamp = dateTime;
    },
    GoToDashBoard() {
      this.$router.push(
        "/QuizStudentDashboard?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    },
    GoToQuiz(startId, timestamp) {
      this.$router.push(
        "/QuizStudentQuestion?quizId=" +
          this.$route.query.quizId +
          "&studentId=" +
          this.$route.query.studentId +
          "&startId=" +
          startId +
          "&userId=" +
          this.$route.query.userId +
          "&endTime=" +
          timestamp
      );
    },
    StudentStartQuizAll() {
      const formData = new FormData();
      formData.append("quizId", this.$route.query.quizId);
      formData.append("studentId", this.$route.query.studentId);

      return this.$API
        .post(this.$StudentStartQuiz, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            var startId = response.data;
            this.getNow(
              this.qSummary.d,
              this.qSummary.h,
              this.qSummary.m,
              this.qSummary.s
            );
            console.log(this.timestamp);
            this.GoToQuizAll(startId,this.timestamp);
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
          }
        });
    },
    GoToQuizAll(startId,timestamp) {
      this.$router.push(
        "/AnswerQuizAll?quizId=" +
          this.$route.query.quizId +
          "&studentId=" +
          this.$route.query.studentId +
          "&startId=" +
          startId +
          "&userId=" +
          this.$route.query.userId +
          "&endTime=" +
          timestamp
      );
    },
  }
};
</script>
